/*
  Click Fencing - delivery date field, 2026-08-17.

  Two faults reported by Pete on the quote-review details modal:

  1. The preferred delivery date was demanded on EVERY DIY quote, including
     pick-up orders. quote-review.js gates it on
     `isDiySubmit = _viewedQuote.pricingType !== "install"` with no test for
     whether the customer actually chose delivery.

  2. The native <input type="date"> offered Saturdays and Sundays, then rejected
     them on change with "We don't deliver on weekends". Offering a choice and
     then refusing it is the worst version of a form. `min` was already set to
     the next business day, but `min` only sets a floor - it cannot skip days.

  Fix: replace the date input with a <select> of real business days, so weekends
  cannot be picked at all, and hide the whole field for pick-up orders.

  Runtime patch, in the same style as cf-gst-display.js / cf-real-line-items.js -
  quote-review.js is 93KB minified and not worth editing in place. The site's own
  submit handler is left completely untouched; this only changes what the field
  is and whether it is shown.
*/
(function () {
  'use strict';
  if (window.__cfDeliveryFixInstalled) return;
  window.__cfDeliveryFixInstalled = true;

  var FIELD_ID = 'qr-f-deliverydate';
  var DAY_COUNT = 20;                 // ~4 working weeks of choices
  var CALCS = ['ullc', 'blade', 'flattop', 'perfmesh'];
  var DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function pretty(d) { return DAY[d.getDay()] + ' ' + d.getDate() + ' ' + MON[d.getMonth()] + ' ' + d.getFullYear(); }

  /* THE RULES LIVE ON THE businesses ROW, NOT HERE. 2026-09-11.
     The 10am next-day cut-off, the Mon-Fri week and any closed dates are turned
     into a list of days by earliest_fulfilment() in the CRM, served read-only by
     the fulfilment-rules edge function. Shared with cf-pickup-slot.js through
     window.__cfFulfilmentRulesP, so the page asks once.
     If it cannot be reached the old "next business day" list below is the
     fallback, and route-paid-orders re-checks every date against
     earliest_fulfilment() at routing time, so a fallback date is flagged, not
     silently promised. */
  var RULES_URL = 'https://mhzmtafzxeshqqtktbwh.supabase.co/functions/v1/fulfilment-rules?business=click';
  function rulesPromise() {
    if (!window.__cfFulfilmentRulesP) {
      window.__cfFulfilmentRulesP = fetch(RULES_URL, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (j && j.ok) { window.__cfFulfilmentRules = j; return j; } return null; })
        .catch(function () { return null; });
    }
    return window.__cfFulfilmentRulesP;
  }
  function ruleDays() {
    var R = window.__cfFulfilmentRules;
    if (!R || !R.delivery_days || !R.delivery_days.length) return null;
    var out = [];
    for (var i = 0; i < R.delivery_days.length; i++) {
      var s = String(R.delivery_days[i].date || '');
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) out.push(new Date(s + 'T00:00:00'));
    }
    return out.length ? out : null;
  }

  /* FALLBACK ONLY - business days starting the next business day. */
  function businessDays(n) {
    var out = [], d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 1);
    while (out.length < n) {
      var g = d.getDay();
      if (g !== 0 && g !== 6) out.push(new Date(d.getTime()));
      d.setDate(d.getDate() + 1);
    }
    return out;
  }

  /* Which quote is on screen. Mirrors cf-gst-display.js: the active pill's
     label wins, then the calculator's active quote, then the newest. */
  function candidates() {
    var out = [];
    for (var i = 0; i < CALCS.length; i++) {
      var c = CALCS[i], active = null;
      try { active = JSON.parse(localStorage.getItem(c + '_active_quote') || 'null'); } catch (e) {}
      if (active && active.breakdown && active.breakdown.length) out.push(active);
      var arr = [];
      try { arr = JSON.parse(localStorage.getItem(c + '_quotes') || '[]') || []; } catch (e) {}
      if (Object.prototype.toString.call(arr) === '[object Array]') {
        for (var j = 0; j < arr.length; j++) {
          var q = arr[j];
          if (q && q.breakdown && q.breakdown.length) out.push(q);
        }
      }
    }
    return out;
  }

  function viewedQuote() {
    var list = candidates();
    if (!list.length) return null;
    var pill = document.querySelector('.qr-quote-pill.is-active');
    var label = pill ? String(pill.textContent || '').trim() : '';
    if (label) {
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].quoteName || '').trim() === label) return list[i];
      }
    }
    var newest = null;
    for (var k = 0; k < list.length; k++) {
      if (!newest || (list[k].generatedAt || 0) > (newest.generatedAt || 0)) newest = list[k];
    }
    return newest;
  }

  /* quote-review.js titles the delivery group by testing its line items:
       delivery.some(it => /pickup/i.test(it.item)) ? "Pickup" : "Perth Metro Delivery"
     Use the same signal rather than reading the rendered accordion, whose row
     is labelled "Delivery" either way. Unknown -> treat as delivery, so an
     unrecognised quote still asks for a date rather than silently skipping it. */
  function isPickup() {
    var q = viewedQuote();
    if (!q || !q.breakdown || !q.breakdown.length) return false;
    var sawDelivery = false, sawPickup = false;
    for (var i = 0; i < q.breakdown.length; i++) {
      var line = q.breakdown[i] || {};
      var text = String(line.item || line.name || line.title || '');
      if (/pick\s*-?\s*up/i.test(text)) sawPickup = true;
      else if (/deliver/i.test(text)) sawDelivery = true;
    }
    return sawPickup && !sawDelivery;
  }

  /* The label + control + helper line, so pick-up hides the lot and not just
     the input, which would leave an orphan "Preferred Delivery Date" heading. */
  function fieldGroup(el) {
    var node = el;
    for (var hops = 0; hops < 5 && node && node.parentElement; hops++) {
      node = node.parentElement;
      var t = String(node.textContent || '');
      if (/Preferred Delivery Date/i.test(t) && t.length < 500) return node;
    }
    return el.parentElement || el;
  }

  function buildSelect(from) {
    var sel = document.createElement('select');
    sel.id = FIELD_ID;
    sel.className = from.className || '';
    if (from.name) sel.name = from.name;
    sel.setAttribute('data-cf-weekdays', '1');
    if (from.required) sel.required = true;

    var fromRules = ruleDays();
    sel.setAttribute('data-cf-rules', fromRules ? '1' : '0');
    var days = fromRules || businessDays(DAY_COUNT);
    var blank = document.createElement('option');
    blank.value = '';
    blank.textContent = 'Choose a weekday…';
    sel.appendChild(blank);
    for (var i = 0; i < days.length; i++) {
      var o = document.createElement('option');
      o.value = iso(days[i]);
      o.textContent = pretty(days[i]);
      sel.appendChild(o);
    }
    /* quote-review.js compares `value < el.min` at submit. A <select> has no
       native min; this expando satisfies the check and is otherwise inert. */
    sel.min = days.length ? iso(days[0]) : '';
    return sel;
  }

  function apply() {
    var el = document.getElementById(FIELD_ID);
    if (!el) return;

    /* Rebuild once more when the rules arrive after a fallback list was drawn.
       A value the rules no longer allow is dropped rather than kept. */
    var stale = window.__cfFulfilmentRules && el.getAttribute &&
                el.getAttribute('data-cf-rules') !== '1';
    if (!el.getAttribute || el.getAttribute('data-cf-weekdays') !== '1' || stale) {
      var sel = buildSelect(el);
      if (el.value) sel.value = el.value;          // silently stays '' if not offered
      if (el.parentNode) el.parentNode.replaceChild(sel, el);
      el = sel;
    }

    var group = fieldGroup(el);
    if (isPickup()) {
      if (group && group.style) group.style.display = 'none';
      /* The site's own handler blocks submit on an empty date for any DIY
         quote. Rather than edit that 93KB handler, satisfy it with the first
         available business day - the customer never sees the field, and the
         value is a sane "ready by" date for a pick-up order. */
      if (!el.value && el.options && el.options.length > 1) el.value = el.options[1].value;
    } else {
      if (group && group.style && group.style.display === 'none') group.style.display = '';
    }
  }

  function schedule() {
    if (schedule._t) return;
    schedule._t = setTimeout(function () { schedule._t = null; try { apply(); } catch (e) {} }, 60);
  }

  function start() {
    /* Only the quote-review page has the field; do not call the CRM from every page. */
    if (/\/pages\/quote-review/.test(location.pathname)) rulesPromise().then(function () { schedule(); });
    schedule();
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    /* Quote pills switch which quote is on screen, which can flip pick-up. */
    document.addEventListener('click', schedule, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
